// Define the literal group names first for type safety
export const EntraGroupNames = {
  Agent: "Agent",
  Passenger: "Passenger",
  TravelProfessional: "Travel Professional",
  CCC: "CCC"
} as const;

// Define a type for the keys
export type EntraGroupKey = keyof typeof EntraGroupNames;

// Define the GUIDs mapping - both prod and non-prod IDs will be checked
export const EntrGroups = {
  // Both production and non-production IDs
  Passenger: ["6c48d673-622e-4b5d-9211-06edd73a1034", "d088118e-6f38-486e-80a9-699624b309a3"],
  Agent: ["04857388-4187-4023-a23d-b2af928f90fc", "aa6b6ec1-c1b1-4d13-9fc1-5abb40c15686"],
  TravelProfessional: [
    "b854bd54-2b5e-411b-8578-34e60522b315",
    "bfc9a01b-4f4a-4acd-9b07-928c091e20cd"
  ],
  CCC: ["2250bcb0-f631-4327-a8ab-3ecc0e3a73ec", "9af665d5-d0de-4491-affc-c7e56f15c4d4"]
};
